const partition = <T>(array: Array<T>, isValid: (t: T) => boolean) => {
  return array.reduce(
    ([pass, fail], elem: T) => {
      return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    },
    [[], []] as T[][],
  );
};

export default partition;
